/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeResponsiveTypography } from './ChallengeResponsiveTypography';
import {
    ChallengeResponsiveTypographyFromJSON,
    ChallengeResponsiveTypographyFromJSONTyped,
    ChallengeResponsiveTypographyToJSON,
    ChallengeResponsiveTypographyToJSONTyped,
} from './ChallengeResponsiveTypography';

/**
 * Style configuration for a page section.
 * @export
 * @interface ChallengeSectionStyleConfig
 */
export interface ChallengeSectionStyleConfig {
    /**
     * 
     * @type {string}
     * @memberof ChallengeSectionStyleConfig
     */
    backgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeSectionStyleConfig
     */
    textColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeSectionStyleConfig
     */
    accentColor?: string;
    /**
     * 
     * @type {ChallengeResponsiveTypography}
     * @memberof ChallengeSectionStyleConfig
     */
    headingTypography?: ChallengeResponsiveTypography;
    /**
     * 
     * @type {ChallengeResponsiveTypography}
     * @memberof ChallengeSectionStyleConfig
     */
    bodyTypography?: ChallengeResponsiveTypography;
}

/**
 * Check if a given object implements the ChallengeSectionStyleConfig interface.
 */
export function instanceOfChallengeSectionStyleConfig(value: object): value is ChallengeSectionStyleConfig {
    return true;
}

export function ChallengeSectionStyleConfigFromJSON(json: any): ChallengeSectionStyleConfig {
    return ChallengeSectionStyleConfigFromJSONTyped(json, false);
}

export function ChallengeSectionStyleConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeSectionStyleConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'backgroundColor': json['backgroundColor'] == null ? undefined : json['backgroundColor'],
        'textColor': json['textColor'] == null ? undefined : json['textColor'],
        'accentColor': json['accentColor'] == null ? undefined : json['accentColor'],
        'headingTypography': json['headingTypography'] == null ? undefined : ChallengeResponsiveTypographyFromJSON(json['headingTypography']),
        'bodyTypography': json['bodyTypography'] == null ? undefined : ChallengeResponsiveTypographyFromJSON(json['bodyTypography']),
    };
}

export function ChallengeSectionStyleConfigToJSON(json: any): ChallengeSectionStyleConfig {
    return ChallengeSectionStyleConfigToJSONTyped(json, false);
}

export function ChallengeSectionStyleConfigToJSONTyped(value?: ChallengeSectionStyleConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'backgroundColor': value['backgroundColor'],
        'textColor': value['textColor'],
        'accentColor': value['accentColor'],
        'headingTypography': ChallengeResponsiveTypographyToJSON(value['headingTypography']),
        'bodyTypography': ChallengeResponsiveTypographyToJSON(value['bodyTypography']),
    };
}

